/**user_management
 * Created by wajidafaneh on 4/24/17.
 */
(function (angular) {

    "use strict";
    angular
        .module('harriApp')
        .controller('HMAPDashboardController', ["$scope", "$window", "$state", "$stateParams", "$location", "hUser", "$modal", "hmapService", "userPermissions", "$filter", "$q", "hEmployeeSatisfactionService", "$element", "userBrandsTreeService", "brandServices", "hmapUiService", function ($scope, $window, $state, $stateParams, $location, hUser, $modal, hmapService, userPermissions, $filter, $q, hEmployeeSatisfactionService, $element, userBrandsTreeService, brandServices, hmapUiService) {
            var activeBrandId = hmapService.getActiveBrand();

            $scope.isLoading = false;
            $scope.subwayBrandType = $stateParams['hmapPath'] ? "enterprise" : "GP-1";
            $scope.brands = [];
            $scope.brandsSatisfactionModels = {};
            $scope.isEmployeeSatisfactionServiceEnabled = false;
            $scope.activeBrandPath = hmapService.activeBrandPath;
            $scope.brandsTree = hmapService.brandsTree;
            $scope.breadcrumbs = hmapService.breadcrumbs;
            var HMAP_UI_VIEW = hmapUiService.HMAP_UI_VIEW;
            var HMAP_VIEW = hmapUiService.HMAP_VIEW;
            var BRAND_SORTING = hmapUiService.BRAND_SORTING;
            $scope.hmapUIOptions = [HMAP_UI_VIEW.CARDS, HMAP_UI_VIEW.LIST];
            $scope.hmapViews = [HMAP_VIEW.ALL, HMAP_VIEW.STARRED];
            $scope.activeUiView = hmapUiService.getActiveUiView();
            $scope.sortingOptions = [BRAND_SORTING.ALPHABETICAL, BRAND_SORTING.GROUPED_BY_PARENT];
            $scope.activeSorting = hmapUiService.getHmapActiveSorting();
            $scope.isExpandingSameGPLevel = hmapUiService.getExpandingBrands().SAME_GP_LEVEL;
            $scope.isExpandingNewGPLevel = hmapUiService.getExpandingBrands().NEW_GP_LEVEL;


            hmapService.onGPPolicyLoaded(function () {
                $scope.gpPolicies = hmapService.gpPolicies;
            });

            $scope.setActiveUiView = function (view) {
                $scope.activeUiView = view;
                hmapUiService.setActiveUiView($scope.activeUiView);
                if (view.name === HMAP_UI_VIEW.LIST.name) {
                    updateListLayoutScrolling();
                }
            };

            $scope.searchChanged = function (searchText) {
                hmapService.setSearchTermTimeout(function () {
                    hmapService.searchTextUpdated(searchText);
                });
            }

            $scope.setHmapView = function (view) {
                $scope.currentActiveView = angular.copy($scope.activeView)
                $scope.activeView = view;
                hmapUiService.setHmapActiveView(view);
                handleViewIfSubwayEnabled();
                init();
            };

            var evaluateBrandsList = function (enterpriseBrand) {
                var defer = $q.defer();

                hmapService.evaluateBrandsList(enterpriseBrand)
                    .then(function (res) {
                        $scope.activeBrandPath = res.activeBrandPath;
                        $scope.brandsTree = res.brandsTree;
                        $scope.breadcrumbs = res.breadcrumbs;
                        updateListLayoutScrolling();
                        defer.resolve({});
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    })
                    .finally(function () {
                        $scope.$evalAsync();
                    });

                return defer.promise;
            };

            var updateListLayoutScrolling = function () {
                setTimeout(function () {
                    var hmapListElement = $element.find('.hmap-list-layout').first();
                    if (hmapListElement.length) {
                        hmapListElement.each(function (index, element) {
                            element.scrollLeft = element.scrollWidth;
                        });
                    }
                }, 1)
            };

            var checkTeamScheduleUserAccess = function(brand) {
                var defer = $q.defer();

                userPermissions
                    .getBrandPolicy(brand.id)
                    .then(function (parser) {
                        var services = brand.policy && brand.policy.services;
                        var teamScheduleService  = false;
                        if (services) {
                            teamScheduleService = services.filter(function (service) {
                                return service.code === 'TEAM_SCHEDULING' && service.type === 'ACTIVE';
                            })[0];
                        }

                        if (!parser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) && !teamScheduleService) {
                            openBrandAccessAlert();
                            defer.reject();
                        } else {
                            defer.resolve();
                        }
                    }, function (error) {
                        defer.reject();
                        console.error(error);
                    });

                return defer.promise;
            };

            const setUserContext = function (userContext) {
                hUser.setUserContext(userContext)
                    .then(() => {
                        $state.go('appLayout.harriSH.dashboard');
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            };

            $scope.launchBrandAction = function (brand) {
                const promises = {
                    teamScheduleUserAccessCheck: checkTeamScheduleUserAccess(brand),
                    accessType: brandServices.getBrandAccessType(brand.id),
                };

                let userContext = {
                    brand_id: brand.id,
                    brand_type: brand.type,
                    active_brand_id: brand.id,
                    active_brand_type: brand.type,
                };

                $q.all(promises)
                    .then(function (res) {
                        const accessType = res.accessType;

                        if (accessType === 'PASS') {
                            BrandAPI.userBrandsByGroupId(brand.id)
                                .then(function (userBrandsList) {
                                    if (userBrandsList && userBrandsList.length) {
                                        userContext.active_brand_id = userBrandsList[0].id;
                                        userContext.active_brand_type = userBrandsList[0].type;
                                        setUserContext(userContext);
                                    }
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });
                        } else {
                            setUserContext(userContext);
                        }
                    })
                    .catch(function (err) {
                        console.error(err)
                    });
            };

            $scope.fireBrandAction = function (brand) {
                var hmapPath;
                var loadedGPs = _.pluck(hmapService.brandLevelsMap, 'type');

                if (brand.type === 'enterprise') {
                    evaluateBrandsList(brand)
                        .then(function () {
                            updateListLayoutScrolling();
                        });
                    return;
                }

                if (hmapService.activeBrandPath.indexOf(brand.id) > -1) {
                    var nestedBrandIds = [];
                    for (var i = 1; i < hmapService.activeBrandPath.length; i++) {
                        var brandId = hmapService.activeBrandPath[i];

                        if (brandId === brand.id) {
                            break;
                        }
                        nestedBrandIds.push(brandId);
                    }
                    hmapPath = nestedBrandIds.join('-');
                } else if (loadedGPs.indexOf(brand.type) > -1) {
                    $scope.isExpandingSameGPLevel = true;
                    hmapUiService.setExpandingBrands('SAME_GP_LEVEL', true);
                    var brandIds = [];
                    var gpKeys = Object.keys(hmapService.brandLevelsMap);
                    var sameGPLevelBrandId = parseInt(gpKeys[loadedGPs.indexOf(brand.type)]);

                    for (var j = 1; j < hmapService.activeBrandPath.length; j++) {
                        var expandedBrandId = hmapService.activeBrandPath[j];

                        if (expandedBrandId === sameGPLevelBrandId) {
                            brandIds.push(brand.id);
                            break;
                        }
                        brandIds.push(expandedBrandId);
                    }
                    hmapPath = brandIds.join('-');
                } else if (hmapService.activeBrandPath.indexOf(brand.id) === -1) {
                    $scope.isExpandingNewGPLevel = true;
                    hmapUiService.setExpandingBrands('NEW_GP_LEVEL', true);
                    hmapPath = $stateParams.hmapPath ? $stateParams.hmapPath + "-" + brand.id : brand.id;
                }

                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main", {hmapPath: hmapPath});
            };

            var loadSatisfaction = function () {
                userPermissions.getBrandPolicy(activeBrandId)
                    .then(function (policyParser) {
                        $scope.hasAccessBrandSatisfactionModel =  policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIEW_SATISFACTION);
                        if ($scope.hasAccessBrandSatisfactionModel) {
                            $scope.showLoader = true;
                            SatisfactionAPI.getBrandSatisfactionModel(activeBrandId, activeBrandId).then(function (brands) {
                                $scope.showLoader = false;
                                var verySatisfiedColor = '#4CAF50';
                                var someWhatSatisfiedColor = '#2CE3A0';
                                var someWhatDissatisfiedColor = '#FEC023';
                                var DissatisfiedColor = '#E02020';
                                brands.forEach(function (brand) {
                                    brand.statsBarInfo = [];
                                    brand.dataInfo = [];

                                    brand.dataInfo.push({
                                        color: DissatisfiedColor,
                                        percent: brand.very_dissatisfied_prc || 0,
                                        icon: 'dissatisfied-icon'
                                    });
                                    brand.dataInfo.push({
                                        color: someWhatDissatisfiedColor,
                                        percent: brand.somewhat_dissatisfied_prc || 0,
                                        icon: 'somewhat-dissatisfied-icon'
                                    });
                                    brand.dataInfo.push({
                                        color: someWhatSatisfiedColor,
                                        percent: brand.somewhat_satisfied_prc || 0,
                                        icon: 'somewhat-satisfied-icon'
                                    });
                                    brand.dataInfo.push({
                                        color: verySatisfiedColor,
                                        percent: brand.very_satisfied_prc || 0,
                                        icon: 'very-satisfied-icon'
                                    });

                                    if (brand.very_dissatisfied_prc) {
                                        brand.statsBarInfo.push({
                                            label: $filter('translate')('Dissatisfied'),
                                            percent: brand.very_dissatisfied_prc || 0,
                                            color: DissatisfiedColor,
                                        });
                                    }
                                    if (brand.somewhat_dissatisfied_prc) {
                                        brand.statsBarInfo.push({
                                            label: $filter('translate')('Somewhat Dissatisfied'),
                                            percent: brand.somewhat_dissatisfied_prc || 0,
                                            color: someWhatDissatisfiedColor,
                                            nextColor: someWhatSatisfiedColor,
                                        });
                                    }
                                    if (brand.somewhat_satisfied_prc) {
                                        brand.statsBarInfo.push({
                                            label: $filter('translate')('Somewhat Satisfied'),
                                            percent: brand.somewhat_satisfied_prc || 0,
                                            color: someWhatSatisfiedColor,
                                            nextColor: verySatisfiedColor,
                                        });
                                    }
                                    if (brand.very_satisfied_prc) {
                                        brand.statsBarInfo.push({
                                            label: $filter('translate')('Satisfied'),
                                            percent: brand.very_satisfied_prc || 0,
                                            color: verySatisfiedColor,
                                        });
                                    }

                                    if (brand.satisfaction === 'DISSATISFIED') {
                                        brand.satisfactionColor = '#FA5845';
                                    } else if (brand.satisfaction === 'SATISFIED') {
                                        brand.satisfactionColor = '#72DFA2';
                                    } else {
                                        brand.satisfactionColor = '#939393';
                                    }

                                    for (var i = 1; i < brand.statsBarInfo.length; i++) {
                                        if (brand.statsBarInfo[i - 1]) {
                                            brand.statsBarInfo[i].previousColor = brand.statsBarInfo[i - 1].color;
                                        }
                                    }

                                    $scope.brandsSatisfactionModels[brand.brand_id] = brand;
                                });

                                $scope.$digest();
                            });
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            };

            var isManageJobTemplatesAvailable = function (brand) {
                return $scope.userBrandPermissions &&
                    $scope.userBrandPermissions[brand.id] &&
                    $scope.userBrandPermissions[brand.id].hasAccessToSourceHire &&
                    $scope.userBrandPermissions[brand.id].canManageJobTemplates;
            };

            $scope.isTemplatesLinkAvailable = function (brand) {
                return isManageJobTemplatesAvailable(brand);
            };

            $scope.getTemplatesLinkHRef = function (brand) {
                var params = {brand_id: brand.id};
                if (isManageJobTemplatesAvailable(brand)) {
                    params.gid = brand.type === 'enterprise' ? brand.id : null;
                    return $state.href('appLayout.harriSH.access-portal.settings.jobTemplates', params);
                }
            };

            $scope.$on('$destroy', function () {
                $(window).off('resize');
            });

            var openTeamLiveDemoModal = function (brand) {
                $modal({
                    controller: 'ScheduleDemoModalController',
                    templateUrl: '../modules/dashboard/views/partials/schedule_team_live_demo_modal.html',
                    show: true,
                    keyboard: false,
                    resolve: {
                        modalData: function () {
                            return {
                                feature: 'TEAM_LIVE',
                                brand: brand,
                            };
                        },
                        onScheduleDemoSuccess: function () {
                            return function () {
                                hAlert('<i class="fa fa-check-circle-o"></i> ' + $filter("translate")("Thank you") + "!",
                                    $filter("translate")("Thank you for your request for a demo") + " TeamLive™. " + $filter("translate")("One of our talent specialists will be in touch with you shortly") + ".",
                                    null,
                                    "schedule-demo-success-alert");
                            }
                        }
                    }
                });
            };

            var openBrandAccessAlert = function () {
                hAlert(
                    $filter("translate")("No access"),
                    $filter("translate")("You do not have access to manage this area") + ". " + $filter("translate")("If you think this is a mistake") + ", " + $filter("translate")("please contact your system administrator") + ". ");
            };

            $scope.goToSchedule = function (brand) {
                var promises = {
                    isTeamSchedulingEnabled: brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brand.id, true),
                    policyParser: userPermissions.getBrandPolicy(brand.id),
                };

                $q.all(promises)
                    .then(function (res) {
                        var isTeamSchedulingEnabled = res.isTeamSchedulingEnabled;
                        var policyParser = res.policyParser;
                        var hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM)

                        if (!hasAccessToTeam) {
                            openBrandAccessAlert();
                            return;
                        }

                        if (isTeamSchedulingEnabled) {
                            hUser.setUserContext({
                                brand_id: brand.parent_id,
                                brand_type: "enterprise",
                                active_brand_id: brand.id,
                                active_brand_type: brand.type,
                            })
                                .finally(async () => {
                                    $state.go("appLayout.schedule.main", {brandId: brand.id});
                                })
                                .catch((err) => {
                                    console.error(err);
                                });
                        } else {
                            openTeamLiveDemoModal(brand);
                        }
                    });
            };

            $scope.goToHiringDashboard = function (brand) {
                userPermissions.getBrandPolicy(brand.id)
                    .then(function (policyParser) {
                        var hasAccessToSourceAndHire = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);

                        if (hasAccessToSourceAndHire) {
                            hUser.setUserContext({
                                brand_id: brand.parent_id,
                                brand_type: "enterprise",
                                active_brand_type: brand.type,
                                active_brand_id: brand.id,
                            })
                                .then(function () {
                                    Utils.redirectToWorkspace("appLayout.harriSH.dashboard-hiring");
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });
                        } else {
                            openBrandAccessAlert();
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            };

            var forceCardsViewOnMobile = function () {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)");

                if (isMobile && isMobile.matches) {
                    $scope.setActiveUiView(HMAP_UI_VIEW.CARDS);
                }
            };

            $scope.runHmapListeners = function () {
                $(window).on('resize', () => {
                    forceCardsViewOnMobile();
                    $scope.$digest();
                });
            };

            $scope.setBrandSorting = function (option) {
                $scope.activeSorting = option;
                hmapUiService.setHmapActiveSorting(option);
                init();
            };

            var loadAllBrands = function () {
                $scope.isLoading = true;

                if (hmapUiService.getFirstLoad()) {
                    $scope.isFirstLoad = true;
                    hmapUiService.setFirstLoad(false);
                }

                var expandingBrands = hmapUiService.getExpandingBrands();

                if (expandingBrands.SAME_GP_LEVEL) {
                    $scope.isExpandingSameGPLevel = true;
                    hmapUiService.setExpandingBrands('SAME_GP_LEVEL', false);
                }

                if (expandingBrands.NEW_GP_LEVEL) {
                    $scope.isExpandingNewGPLevel = true;
                    hmapUiService.setExpandingBrands('NEW_GP_LEVEL', false);
                }

                var initPromises = {
                    gpDetails: $q.defer(),
                    gpPolicy: $q.defer()
                };
                //Load gps
                GPSAPI.getGP(activeBrandId)
                    .then(function (res) {
                        initPromises.gpDetails.resolve(res);
                    }, function (err) {
                        console.error("couldn't load gb", err);
                        initPromises.gpDetails.reject("couldn't load gb");
                    });

                //Trigger loading policies
                hmapService.loadGPPlociy(activeBrandId)
                    .then(function (policy) {
                        initPromises.gpPolicy.resolve(policy);
                    });


                $q.all({
                    gpDetails: initPromises.gpDetails.promise,
                    gpPolicy: initPromises.gpPolicy.promise,
                    brandsList: evaluateBrandsList()
                })
                    .then(function (result) {
                        var brands = _.map(result.gpDetails.brands, function (brand) {

                            brand.policy = _.find(result.gpPolicy.brands, function (policyBrand) {
                                return policyBrand.id === brand.id;
                            });

                            for(var i in brand.policy.services){
                                if (brand.policy.services[i].code === "EMPLOYEE_SATISFACTION_MODEL" && brand.policy.services[i].type == "ACTIVE") {
                                    $scope.isEmployeeSatisfactionServiceEnabled = true;
                                }
                            }

                            return brand;
                        });

                        $scope.brands = [{
                            details: {id: hUser.getUserContext().brand_id, type: 'HIGHEST'},
                            children: brands
                        }];

                        hEmployeeSatisfactionService.isEmployeeSatisfactionEnabled(activeBrandId)
                            .then(function (isEmployeeSatisfactionServiceEnabled) {
                                $scope.isEmployeeSatisfactionServiceEnabled = isEmployeeSatisfactionServiceEnabled;
                                if ($scope.isEmployeeSatisfactionServiceEnabled) {
                                    loadSatisfaction();
                                }
                            })
                        $scope.isLoading = false;
                        $scope.isFirstLoad = false;
                        $scope.isExpandingSameGPLevel = false;
                        $scope.isExpandingNewGPLevel = false;
                        updateListLayoutScrolling();
                    })
                    .finally(function () {
                        forceCardsViewOnMobile();
                    });
            };

            $scope.showLoaderSection = function () {
                return (
                    ($scope.activeUiView.name === 'CARDS' && $scope.activeView.name === 'ALL' && $scope.isLoading) ||
                    ($scope.activeView.name === 'STARRED' && $scope.loadingStarredBrands) ||
                    ($scope.activeUiView.name === 'LIST' && $scope.activeView.name === 'ALL' && $scope.isFirstLoad)
                );
            };

            var updateHmapBrandStarStatus = function (brandId, starValue) {
                for (var i = 0; i < $scope.brands.length; i++) {
                    var parent = $scope.brands[i];

                    if (parent.children && parent.children.length) {
                        var brand = parent.children.find(function (brand) {
                            return brand.id === brandId;
                        });

                        if (brand) {
                            brand.is_favourite = starValue;
                            $scope.$evalAsync();
                        }
                    }
                }

                for (var j = 0; j < $scope.brandsTree.length; j++) {
                    var brandTree = $scope.brandsTree[j];
                    if (brandTree.brands && brandTree.brands.length) {
                        var affectedBrand = brandTree.brands.find(function (brand) {
                            return brand.id === brandId;
                        });

                        if (affectedBrand) {
                            affectedBrand.is_favourite = starValue;
                            $scope.$evalAsync();
                            break;
                        }
                    }
                }
            };

            $scope.toggleBrandStar = function (brand) {
                var method;
                brand.starLoading = true;

                if (brand.is_favourite) {
                    method = BrandAPI.unstarBrand;
                } else {
                    method = BrandAPI.starBrand;
                }

                method(brand.id)
                    .then(function () {
                        userBrandsTreeService.updateBrandStarStatus(brand.id, !brand.is_favourite);
                        var msg = "";
                        if (!brand.is_favourite) {
                            msg = $filter('translate')("Added") + " " + brand.name + " " + $filter('translate')("to Starred");
                        } else {
                            msg = $filter('translate')("Removed") + " " + brand.name + " " + $filter('translate')("from Starred");
                        }
                        HNotifications.show({
                            title: $filter('translate')("Success"),
                            desc: msg,
                            icon: "fa-check-circle",
                            type: "success"
                        });
                    })
                    .catch(function (err) {
                        console.error(err);
                        HNotifications.show({
                            title: $filter('translate')("Something went wrong") + "!",
                            desc: $filter('translate')("Please try again") + "!",
                            icon: "fa-times",
                            type: "danger",
                            timeout: 3000
                        });
                    })
                    .finally(function () {
                        brand.starLoading = false;
                        $scope.$evalAsync();
                    });
            };

            var loadStarredBrands = function () {
                $scope.loadingStarredBrands = true;

                userBrandsTreeService.getUserFavouriteBrandsTree().then(function (favouriteBrands) {
                    if ($scope.activeSorting.name === BRAND_SORTING.GROUPED_BY_PARENT.name) {
                        $scope.brands = prepareStarredBrandsList(favouriteBrands);
                    } else {
                        $scope.brands = [{
                            details: {id: hUser.getUserContext().brand_id, type: 'HIGHEST'},
                            children: userBrandsTreeService.getFavouriteBrandsFlatData()
                        }];
                    }
                }).catch(function (err) {
                    console.error(err);
                }).finally(function () {
                    $scope.loadingStarredBrands = false;
                    forceCardsViewOnMobile();
                });
            };

            userBrandsTreeService.on(userBrandsTreeService.EVENTS.BRANDS_UPDATED, function (brandId, isFavourite) {
                if ($scope.activeView.name === HMAP_VIEW.STARRED.name) {
                    loadStarredBrands();
                } else {
                    updateHmapBrandStarStatus(brandId, isFavourite);
                }
            });

            var prepareStarredBrandsList = function (starredBrandsList) {
                var groupedStarredBrands = [];

                for (var i = 0; i < starredBrandsList.length; i++) {
                    if (starredBrandsList[i].brands.length) {
                        var parentBrand = starredBrandsList[i];
                        var parentStarredBrands = [];

                        for (var j = 0; j < starredBrandsList[i].brands.length; j++) {
                            var brand = angular.copy(starredBrandsList[i].brands[j]);
                            parentStarredBrands.push(brand);
                        }
                        if (parentStarredBrands.length) {
                            groupedStarredBrands.push({details: parentBrand, children: parentStarredBrands});
                        }
                    }
                }
                return groupedStarredBrands;
            };

            var handleViewIfSubwayEnabled = function () {
                var subwayEnabled = $scope.hmapViews.some(function (view) {
                    return (view.name === HMAP_VIEW.SUBWAY_VIEW.name)
                });

                if (subwayEnabled) {
                    if ([HMAP_VIEW.SUBWAY_VIEW.name, HMAP_VIEW.ALL.name].indexOf($scope.activeView.name) > -1 ||
                        ($scope.currentActiveView && [HMAP_VIEW.SUBWAY_VIEW.name, HMAP_VIEW.ALL.name].indexOf($scope.currentActiveView.name) > -1)) {
                        Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: ""})
                    }
                }
            };

            var init = function () {
                hmapUiService.prepareDashboardViews()
                    .then(function (views) {
                        $scope.hmapViews = views;
                        $scope.activeView = hmapUiService.getHmapActiveView();
                        if ($scope.activeView.name !== HMAP_VIEW.SUBWAY_VIEW.name) {
                            if ($scope.activeView.name === HMAP_VIEW.STARRED.name) {
                                loadStarredBrands();
                            } else {
                                loadAllBrands();
                            }
                        }
                    })
            };

            (function () {
                userBrandsTreeService.clearBrandTreeCache();
                init();
            })();
        }]);
})(angular);
